import { useContext } from "react";
import { useQuery } from "react-query";
import * as api from "../../services";
import AppContext from "../../appContext";

const initNotes = [];

export default function useNotes() {
  const {
    app: {
      client: { id: clientId },
      project: { id: projectId },
      pauseQueries,
      sessionId,
    },
  } = useContext(AppContext);
  const {
    data: notes,
    isLoading: isNotesLoading,
    isError: isNotesError,
    refetch: refetchNotes,
  } = useQuery(
    ["notes", clientId, projectId, sessionId],
    () =>
      api.getNotes({ clientId, projectId, sessionId }).then(({ data }) => {
        return data?.notes ?? initNotes;
      }),
    {
      placeholderData: () => undefined,
      enabled: clientId !== -1 && !pauseQueries,
    }
  );

  return {
    notes,
    isNotesLoading,
    isNotesError,
    refetchNotes,
  };
}
